// extracted by mini-css-extract-plugin
export default {"normal":"Button_normal__BrbVd","ghost":"Button_ghost__f2-K0"};